import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../App";
import ProductCard from "./ProductCard";

export default function RelatedProducts({ productId }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API}/products/${productId}/related`, { params: { limit: 4 } })
      .then((r) => setItems(r.data || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [productId]);

  if (loading || items.length === 0) return null;

  return (
    <section className="mt-16 pt-10 border-t border-[#EAE3D9]" data-testid="related-products">
      <div className="flex items-end justify-between mb-6">
        <div>
          <p className="label-small text-[#C5A059] mb-2">Handpicked for you</p>
          <h2 className="font-display text-3xl text-[#2C2A29]">You may also love</h2>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6" data-testid="related-products-grid">
        {items.map((p) => (
          <ProductCard key={p.product_id} p={p} />
        ))}
      </div>
    </section>
  );
}
